export const Open = {
    id: 1,
    value: 'OPEN',
    name: 'Open',
};
export const Completed = {
    id: 3,
    value: 'COMPLETED',
    name: 'Completed',
};
export const OnHold = {
    id: 5,
    value: 'ON_HOLD',
    name: 'On Hold',
};
const Basic = [Open, OnHold, Completed];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const BasicProps = Object.keys(BasicByValue);
export default {
    Basic,
    BasicByValue,
    BasicProps,
};
